import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Log } from '../../models';
import {
    build_eventival_backoffice_url,
    screening_from_import_invalid_entry,
} from '../../services/eventivalUrls';

import './InvalidImportEntryTitle.scss';

/**
 * Title row for an invalid import entry (screening, place, ticket…).
 * Shows an external source icon link when a back-office URL can be built (Eventival today).
 */
const InvalidImportEntryTitle = ({
    importSource,
    setting,
    resource,
    entry,
    title,
    subtitle,
    editPath,
}) => {
    const { t } = useTranslation();

    const external_url = React.useMemo(() => {
        if (importSource !== 'eventival' || resource !== 'screenings')
            return null;
        const screening = screening_from_import_invalid_entry(entry);
        return screening ? build_eventival_backoffice_url(screening, setting) : null;
    }, [entry, importSource, resource, setting]);

    const source_icon = React.useMemo(() => {
        if (!external_url || !importSource)
            return null;
        return new Log({ source: importSource }).sourceIcone();
    }, [external_url, importSource]);

    const external_title = resource === 'screenings'
        ? t('screenings.see_on_eventival')
        : t('common.open_external_source');

    return (
        <div className="InvalidImportEntryTitle d-flex justify-content-between align-items-start mb-1">
            <div className="InvalidImportEntryTitle-main">
                {editPath ? (
                    <Link to={editPath}>
                        <b>{ title }</b>
                    </Link>
                ) : (
                    <b>{ title }</b>
                )}
                {subtitle && (
                    <span className="InvalidImportEntryTitle-subtitle">
                        {' '}- { subtitle }
                    </span>
                )}
            </div>
            {(external_url && source_icon) && (
                <a
                    href={ external_url }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="InvalidImportEntryTitle-source-link ml-2"
                    title={ external_title }
                >
                    <img
                        src={ source_icon }
                        className="img rounded InvalidImportEntryTitle-source-icon"
                        alt={ external_title }
                    />
                </a>
            )}
        </div>
    );
};

export default InvalidImportEntryTitle;
